const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the imported content status component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {UserTracks} UserTracks the resource defined to manage UserTracks
 */
app.directive('importedContentStatus', ['Application', 'Authorization', 'ImportedContentRegistrations', 'ScormRegistrations', '$translate', function(Application, Authorization, ImportedContentRegistrations, ScormRegistrations, $translate) {
    return {
      restrict: 'E',
      template: require('../../templates/directives/imported-content-status.html'),
      controller: function() {
        var self = this;
        self.features = Application.features.flags();
        self.currentTab = 'active';
        self.active_registrations = [];
        self.completed_registrations = [];
        self.sortName = 'createdAt';
        self.sortOrder = -1;
        self.scormLoaded = true;
        self.ICLoaded = true;
        self.initialize = function() {
          self.loading = true;
          self.searchLoading = true;
          self.filter = {
            subresource: 'all',
            page: null,
            per_page: 20,
            user: Authorization.getAuthToken().user._id,
            'user-populate': 'first_name,last_name,email,image,linked_locations,linked_departments',
            'user.linked_locations-populate': 'name',
            'user.linked_departments-populate': 'name',
            'content-populate': 'title,description,vendor,image,banner_image,archived,createdAt',
            fields: 'company,user,content,results,createdAt,status',
            sort: self.sortName + ',' + self.sortOrder
          };
          self.scormFilter = {
            subresource: 'all',
            users: [Authorization.getAuthToken().user._id],
            sort: {'createdAt': -1},
          };
          if (self.features.udemy || self.features.linkedin_learning || self.features.enable_masterclass) {
            self.ICLoaded = false;
            ImportedContentRegistrations.find(self.filter).$promise.then(function(items) {
              self.allowNext = true;
              self.allowPrevious = true;
              items.forEach(function(item) {
                item.type = 'imported_content';
                item.passed_failed_status = 'unknown';
                item.seconds_spent = '';
                item.completed = false;
                item.score = 'unknown';
                item.progress = 'unknown';
                item.timestamp = null;
                if (!item.results || item.results.length === 0) {
                  return;
                }
                if (!item.content || item.content.archived === true) {
                  return;
                }
                var latest_progress = item.results.find(function(result) {
                  return result.name === 'latest_progress';
                });
                if (!latest_progress) {
                  return;
                }
                latest_progress.object = JSON.parse(latest_progress.value);
                item.passed_failed_status = 'unknown';
                // Do not overwrite completed status if we have a top level completed value
                if (item.completed === false) {
                  item.completed = (latest_progress.object.course_completion_date || parseInt(latest_progress.object.completion_ratio) === 100);
                }
                // Do not overwrite completed date if we have a top level completed value
                if (item.completed && !item.completed_date) {
                  item.completed_date = moment(latest_progress.object.course_completion_date).local() ? new Date(latest_progress.object.course_completion_date) : new Date();
                }
                item.passed_failed_status = 'unknown';
                item.score = 'unknown';
                item.seconds_spent = latest_progress.object.num_video_consumed_minutes ? parseInt(latest_progress.object.num_video_consumed_minutes * 60) : -1;
                item.progress = latest_progress.object.completion_ratio;
                if (item.completed) {
                  self.completed_registrations.push(item);
                } else {
                  self.active_registrations.push(item);
                }
              });
              self.completed_registrations.sort(function(a, b) {
                return new Date(a.createdAt) - new Date(b.createdAt);
              });
              self.active_registrations.sort(function(a, b) {
                return new Date(a.createdAt) - new Date(b.createdAt);
              });
              self.ICLoaded = true;
            }).catch(function(error) {
              console.log('Error occured getting imported_content ', error);
            });
          }
          if (Authorization.getAuthToken().company && Authorization.getAuthToken().company.scorm) {
            self.scormLoaded = false;
            ScormRegistrations.find(self.scormFilter).$promise.then(function(scorm_items) {
              scorm_items.forEach(function(item) {
                if (!item.content || item.content.archived) {
                  return;
                }
                item.type = 'scorm';
                if (item.completed || item.status === 'passed' || item.status === 'completed') {
                  item.completed = true;
                  self.completed_registrations.push(item);
                } else {
                  self.active_registrations.push(item);
                }
              });
              self.completed_registrations.sort(function(a, b) {
                return new Date(a.createdAt) - new Date(b.createdAt);
              });
              self.active_registrations.sort(function(a, b) {
                return new Date(a.createdAt) - new Date(b.createdAt);
              });
              self.scormLoaded = true;
            }).catch(function(error) {
              console.log('Error occured getting scorm ', error);
            });
          }
        };
        $translate(['modules.notifications.unableToGetExternalCourses']).then(function(data) {
          self.translations = data;
          self.initialize();
        });
      },
      controllerAs: 'importedContentStatus'
    };
  }]);
